import { render, staticRenderFns } from "./PriceRange.vue?vue&type=template&id=35465bd0"
import script from "./PriceRange.vue?vue&type=script&lang=js"
export * from "./PriceRange.vue?vue&type=script&lang=js"
import style0 from "./PriceRange.vue?vue&type=style&index=0&id=35465bd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports